import type { VariantProps } from 'cva'
import { cva } from 'cva'
import type { ComponentProps, FC } from 'react'

const infoStripVariants = cva({
	base: 'border-b border-b-grey-20',
	variants: {
		size: {
			sm: 'pb-lg text-body-sm',
			md: 'pb-xl text-body-md',
		},
	},
	defaultVariants: {
		size: 'sm',
	},
})

export type InfoStripProps = ComponentProps<'div'> &
	VariantProps<typeof infoStripVariants> & {
		title: string
	}

export const InfoStrip: FC<InfoStripProps> = ({ title, size, className, children, ...props }) => {
	return (
		<div className={infoStripVariants({ size, className })} {...props}>
			<p className="font-semibold">{title}</p>
			<div>{children}</div>
		</div>
	)
}
